import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { isProjectTypeMember } from "@/core/lib/access";
import {
  AUDIT_PROJECT_TYPE,
  CORPORATE_FINANCE_PROJECT_TYPE,
} from "@/core/lib/constants";
import { DEPARTMENT_PROJECT_TYPES } from "@/core/lib/project-types";
import { denyRouteAccess } from "@/core/lib/route-access";
import {
  preloadPromotionReviewQueue,
  promotionReviewSearchSchema,
  requireOrganizationId,
} from "@/features/promotion/lib/promotion-review-route";

const workflowEditorSearchSchema = promotionReviewSearchSchema.extend({
  projectType: z.enum(DEPARTMENT_PROJECT_TYPES).optional(),
});

export const Route = createFileRoute("/_protected/workflow-editor/")({
  validateSearch: workflowEditorSearchSchema,
  beforeLoad: ({ context, search, ...guard }) => {
    const projectType =
      search.projectType ??
      (isProjectTypeMember(context.user, AUDIT_PROJECT_TYPE)
        ? AUDIT_PROJECT_TYPE
        : isProjectTypeMember(context.user, CORPORATE_FINANCE_PROJECT_TYPE)
          ? CORPORATE_FINANCE_PROJECT_TYPE
          : null);

    if (!projectType || !isProjectTypeMember(context.user, projectType)) {
      denyRouteAccess(
        guard,
        projectType ? `${projectType}_membership` : "department_membership",
      );
    }

    if (!search.projectType) {
      throw redirect({
        to: "/workflow-editor",
        search: { ...search, projectType },
        replace: true,
      });
    }
  },
  loader: ({ context: { queryClient, user } }) => {
    const orgId = requireOrganizationId(user.organization?.id);
    preloadPromotionReviewQueue(queryClient, orgId, "workflow_set");
  },
});
